import * as AF from "@/components/form-items/AbstractForm";
import { useAuth } from "@/context/auth/AuthContext";
import useImageAttachment from "@/hooks/useImageAttachment";
import { SupportedLocale } from "@/i18n";
import { generateImageName } from "@/lib/utils";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { CroppedImageInput } from "../form-fields/CroppedImageInput";

interface ContactFormProps {
  language: SupportedLocale;
}

export const ContactForm = ({ language }: ContactFormProps) => {
  const { t } = useTranslation();

  const imagePosition = useMemo(
    () => `contactImage${language.toLocaleUpperCase()}`,
    [language],
  );

  const { instanceData } = useAuth();

  const { attachment, imageURL, refetch } = useImageAttachment(
    imagePosition,
    instanceData?.id,
  );

  return (
    <AF.Col>
      <AF.Text
        name={`${language}.pageName`}
        label={t("cms.contact.form.pageName")}
        tootltip={t("cms.contact.form.pageName.tooltip")}
      />

      <AF.RichText
        name={`${language}.content`}
        label={t("cms.contact.form.content")}
      />
      <AF.Text name={`${language}.email`} label={t("cms.contact.form.email")} />
      <CroppedImageInput
        imageURL={imageURL}
        attachment={attachment}
        refetch={refetch}
        imagePosition={imagePosition}
        aspect={0.78}
        title={t("addImageLabel")}
        buttonLabel={t("changePhoto")}
        label={t("contactImageLabel")}
        buildImageName={(instanceName) =>
          generateImageName({
            primaryType: "CMSPages",
            instanceName,
            translatedPageName: t("seo.imageName.contact"),
          })
        }
      />
    </AF.Col>
  );
};
